import { createFileRoute } from "@tanstack/react-router";
import DoesInsuranceCoverSaintPage from "@/pages/learn/DoesInsuranceCoverSaintPage";
import { doesInsuranceCoverSaint } from "@/pages/learn/learnDataDoesInsuranceCoverSaint";
export const Route = createFileRoute("/learn/does-insurance-cover-saint-tms")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Does Insurance Cover SAINT® TMS? | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Does insurance cover SAINT® TMS? Coverage varies by plan. Learn about commercial insurance, Medicare, and free benefits verification in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Does Insurance Cover SAINT® TMS? | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Does insurance cover SAINT® TMS? Coverage varies by plan. Learn about commercial insurance, Medicare, and free benefits verification in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/learn/does-insurance-cover-saint-tms",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/learn/does-insurance-cover-saint-tms",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(doesInsuranceCoverSaint.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DoesInsuranceCoverSaintPage />;
}
